import {
  ITheme,
  IText,
  createPopoverWidget,
  PopoverWidget,
  PopoverPosition
} from '@highloop/feedback';
import React, { useEffect, useMemo, useRef } from 'react';

export let FeedbackButton = (
  props: React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > & {
    id: string;
    resetOnSubmit?: boolean;
    theme?: ITheme;
    text?: IText;
    meta?: any;
    position?: PopoverPosition;
    expanded?: boolean;
    closeOnOutsideClick?: boolean;
  }
) => {
  let ref = useRef<HTMLButtonElement>();
  let instanceRef = useRef<PopoverWidget>();

  useEffect(() => {
    if (!ref.current || typeof window == 'undefined') return;

    createPopoverWidget(props.id, ref.current, {
      theme: props.theme,
      text: props.text,
      meta: props.meta,
      position: props.position,
      closeOnOutsideClick: props.closeOnOutsideClick,
      expanded: props.expanded
    })
      .then(instance => {
        instanceRef.current = instance;
      })
      .catch(err => console.warn('[highloop-feedback]: Could not create widget', err));

    return () => {
      if (!instanceRef.current) return;
      instanceRef.current.destroy();
    };
  }, [props.id]);

  useEffect(() => {
    if (!instanceRef.current) return;
    instanceRef.current.setTheme(props.theme);
  }, [props.theme]);

  useEffect(() => {
    if (!instanceRef.current) return;
    instanceRef.current.setMeta(props.meta);
  }, [props.meta]);

  let buttonProps = useMemo(() => {
    let buttonProps = Object.assign(
      {
        children: 'Feedback',
        style:
          !props.className && !props.style
            ? {
                color: 'white',
                background: 'black',
                height: 34,
                border: 'none',
                borderRadius: 8,
                padding: '0px 14px',
                fontSize: 14,
                fontWeight: 500
              }
            : {}
      },
      props
    );

    delete buttonProps.id;
    delete buttonProps.resetOnSubmit;
    delete buttonProps.theme;
    delete buttonProps.text;
    delete buttonProps.meta;
    delete buttonProps.position;
    delete buttonProps.expanded;
    delete buttonProps.closeOnOutsideClick;

    return buttonProps as React.DetailedHTMLProps<
      React.ButtonHTMLAttributes<HTMLButtonElement>,
      HTMLButtonElement
    >;
  }, [props]);

  return <button {...buttonProps} ref={ref} />;
};
